import { Fragment, useEffect, useState } from "react";
import { Loader, PageLayout } from "../../components";
import { baseUrl, projectDetail } from "../../utils/apiData";
import  VideoLanding from "./videoLanding/VideoLanding";
import { motion } from "framer-motion";
import {
  ProjectDetailLr,
  ProjectSection,
  MagicSlider,
  ProjectImageSlider,
} from "./index";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import GoogleStreetView from "../../components/GoogleStreetView";
import useExecuteContext from "../../utils/hooks/executeContext";

const ProjectDetail = () => {
  const { setCurrentLocation, currentLocation } = useExecuteContext();
  const { slug } = useParams();
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({});
  const [construction, setConstruction] = useState([]);

  const projectDetailAPi = async () => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${projectDetail}`, { slug });
      if (res?.data?.success) {
        setData(res?.data?.data);
        setConstruction(res?.data?.data?.construction);
        setCurrentLocation({
          id: res?.data?.data?._id,
          img: `${baseUrl}/${res?.data?.data?.image}`,
          location: res?.data?.data?.name,
          desc: res?.data?.data?.description,
          lat: +res?.data?.data?.lat,
          lng: +res?.data?.data?.long,
          slug: res?.data?.data?.slug,
          
        });
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    if (slug) {
      projectDetailAPi();
    }
  }, [slug]);

  return (
    <PageLayout>
      {data?.title && (
        <Helmet>
          <title>{`${data?.title} | Exotic Group`}</title>
          <meta name="description" content={`${data?.title} | Exotic Group`} />
        </Helmet>
      )}
      {loader ? (
        <Loader />
      ) : (
        <Fragment>
          <VideoLanding
            title={data?.title}
            para={data?.description}
            videoId={data?.video}
          />
          <div id="second"></div>
          {data?.amenties?.length > 0 && data?.construction_heading && (
            <ProjectSection dataList={construction} data={data} />
          )}

          {data?.section_1_title &&
            data?.section_1_description &&
            data?.construction_images?.length > 0 && (
              <ProjectDetailLr data={data} />
            )}

          {construction?.amenties_all?.length > 0 && construction?.name && (
            <MagicSlider data={construction} />
          )}

          {data?.slider_images?.length > 0 && (
            <ProjectImageSlider data={data?.slider_images} />
          )}

          {currentLocation && data?.explore_title && (
            <section className="street_map">
              <div className="content_wrap p_t p_b">
                <div className="title_wrap">
                  {data?.explore_title && (
                    <h3 className="gold">
                      {data?.explore_title
                        ?.split("")
                        .map((char, k) => (
                          <motion.span
                            initial={{ translateX: 24, opacity: 0 }}
                            whileInView={{ translateX: 0, opacity: 1 }}
                            transition={{
                              duration: 0.4,
                              ease: "easeInOut",
                              delay: 0.04 * k,
                            }}
                            key={k}
                          >
                            {char}
                          </motion.span>
                        ))
                        .concat("")}
                    </h3>
                  )}
                  <p className="gold mt-2">{data?.explore_description}</p>
                </div>

                <GoogleStreetView
                  lat={currentLocation?.lat}
                  lng={currentLocation?.lng}
                />
              </div>
            </section>
          )}
        </Fragment>
      )}
    </PageLayout>
  );
};

export default ProjectDetail;
